import Color from 'color';

export default class ColorUtil {
  static rgbaFromHex(hexString, alpha = 1.0) {
    const color = new Color(hexString);

    return color.alpha(alpha).string();
  }
}



// WEBPACK FOOTER //
// ./src/utils/ColorUtil.js